import React, { useState, useContext } from "react"

const ApartmentListViewContext = React.createContext()
const useApartmentListViewContext = () => useContext(ApartmentListViewContext)


const DEFAULT_VIEW = "visual"

const ApartmentListViewContextProvider = ({ children }) => {
  const [view, setView] = useState(DEFAULT_VIEW)
  const [building, setBuilding] = useState(null);
  const [listView, setListView] = useState("list");

  return (
    <ApartmentListViewContext.Provider value={{view, setView, building, setBuilding, listView, setListView}}>
      {children}
    </ApartmentListViewContext.Provider>
  )
}

export { ApartmentListViewContext, useApartmentListViewContext }
export default ApartmentListViewContextProvider